import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["forwardedRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { CustomPropTypes } from '@beef/react';
import { withForwardedRef } from "../../../enhancers";
export default function withState(WrappedInput) {
  var StatefulInput = /*#__PURE__*/function (_React$Component) {
    _inherits(StatefulInput, _React$Component);
    var _super = _createSuper(StatefulInput);
    function StatefulInput(props) {
      var _this;
      _classCallCheck(this, StatefulInput);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, event) {
        var onChange = _this.props.onChange;
        _this.setState({
          value: value
        });
        if (onChange) onChange(value, event);
      });
      _this.state = {
        /** if value is missing, empty string is used by default */
        value: 'value' in props ? props.value : ''
      };
      return _this;
    }
    _createClass(StatefulInput, [{
      key: "render",
      value: function render() {
        var value = this.state.value;
        var _this$props = this.props,
          forwardedRef = _this$props.forwardedRef,
          otherProps = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/React.createElement(WrappedInput, _extends({}, otherProps, {
          onChange: this.handleChange,
          ref: forwardedRef,
          value: value
        }));
      }
    }]);
    return StatefulInput;
  }(React.Component);
  StatefulInput.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedInput.propTypes), {}, {
    /**
     * onChange is used to maintain value state
     * while `value` acts like initial value
     */
    value: PropTypes.any,
    onChange: PropTypes.func,
    /** is not an actual prop */
    forwardedRef: CustomPropTypes.ref
  }) : {};
  StatefulInput.defaultProps = WrappedInput.defaultProps;

  /**
   * Override component name by prepending `Stateful~`
   * to make it look nice, for example: `StatefulTextInput`
   */
  if (process.env.NODE_ENV !== 'production') {
    var WrappedComponentName = WrappedInput.displayName || WrappedInput.name || 'Input';
    StatefulInput.displayName = "Stateful".concat(WrappedComponentName);
  }
  return withForwardedRef(StatefulInput);
}